const Constants = {
    // Collections Name
    userCollection: "user_collection",
    adminCollection: "admin_collection",
    scoreCollection: "score_collection",
    paymentCollection: "payment_collection",
    categoryCollection: "category",
    subcategoryCollection: "sub_category",
    names: "names",
    trendingNames: "trending_names",
    slogan: 'slogan',
    sloganCategoryCollection: 'slogan_category',

    // filed name
    email: "email",
    password: "password",

    //regex
    emailRegex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,

    // Erorr Messages
    emailErrorMessage: "Email is required.",
    passwordErrorMessage: "Password is required.",
    validEmail: "Please enter valid email.",
    userNotExist: "User does not exist.",
    incorrectPassword: "Password is incorrect.",
    adminEmailError: "Your email is not an admin user"
}

export default Constants;